import classNames from 'classnames'

import Container from '@/components/base/Container'
import Image from '@/components/base/Image'

import { Section, WPImage } from '@/types'

type FullImageProps = Section & {
  image?: WPImage
}

const FullImage = ({ image, className, ...props }: FullImageProps) => {
  return (
    <section className={classNames('mix-blend-multiply', className)} {...props}>
      <Container>
        <span
          className="relative block"
          style={{
            paddingBottom: `calc(${image?.height} / ${image?.width} * 100%)`
          }}
        >
          <Image
            size="full"
            loading="lazy"
            fill
            fit="cover"
            source={image}
            alt={image?.alt}
          />
        </span>
      </Container>
    </section>
  )
}

export default FullImage
